import axios from 'axios'
import { message as Message } from 'ant-design-vue'
import { useStore } from 'vuex'
import { reportWeComGroupQrPushed } from '@/api/workPlace/enterpriseWeChatRecord'
import { sendGuideQrCodeImage } from './guideQrCodeTracking.mjs'

/**
 * 将企业微信二维码下载为图片文件，并复用原有 IM 图片消息能力发送。
 */
export default function useGuideQrCodeImageSender() {
  const store = useStore()

  const sendQrCodeImage = async ({
    url,
    chatId,
    chatToType,
    ucDoctorId,
    ucPatientId,
    workOrderId
  }) => {
    if (!url || !chatId) return false
    try {
      const response = await axios.get(url, {
        responseType: 'blob'
      })
      const mimeType = response.data?.type || 'image/png'
      const originalSuffix = url.split(/[?#]/)[0].match(/\.([a-zA-Z0-9]+)$/)?.[1]
      const filetype = originalSuffix || mimeType.split('/')[1] || 'png'
      const fileName = `wecom-qr-code.${filetype}`
      const file = new File([response.data], fileName, { type: mimeType })
      return await sendGuideQrCodeImage({
        dispatch: store.dispatch,
        sendPayload: {
          chatType: 'group',
          chatId,
          file: {
            data: file,
            filename: fileName,
            filetype
          },
          chatToType,
          ext: {
            is_doctor_private: false
          },
          callback: () => {}
        },
        trackingPayload: {
          ucDoctorId,
          ucPatientId,
          workOrderId
        },
        reportQrPushed: reportWeComGroupQrPushed
      })
    } catch {
      Message.error('二维码发送失败，请稍后重试')
      return false
    }
  }

  return { sendQrCodeImage }
}
